import { render } from "./CatalogPagination.vue?vue&type=template&id=0aad5f49&scoped=true"
import script from "./CatalogPagination.vue?vue&type=script&lang=js"
export * from "./CatalogPagination.vue?vue&type=script&lang=js"

import "./CatalogPagination.vue?vue&type=style&index=0&id=0aad5f49&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aad5f49"]])

export default __exports__